import React, { useState } from 'react';
import { Box, Button, Card, CardContent, TextField, Typography, Alert, CircularProgress } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { authService } from '../services/authService';

const PasswortVergessenPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const result = await authService.requestPasswordReset(email);
      setSuccess(result?.message || 'Wenn ein passendes Konto existiert, wurde eine E-Mail versendet.');
    } catch (err: any) {
      const detail = err?.response?.data?.detail || 'Anfrage konnte nicht verarbeitet werden';
      setError(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#181c34',
        background: 'radial-gradient(ellipse at 50% 0%, #1e2340 0%, #181c34 70%)',
      }}
    >
      <Card
        sx={{
          width: { xs: '100%', sm: 460 },
          maxWidth: '100%',
          mx: { xs: 2, sm: 'auto' },
          bgcolor: '#212744',
          border: '1px solid #2e3560',
          borderRadius: 3,
          boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Typography variant="h5" sx={{ color: '#3dd47e', fontWeight: 700, mb: 1 }}>
            Passwort vergessen
          </Typography>
          <Typography variant="body2" sx={{ color: '#8899aa', mb: 3 }}>
            Gib deine E-Mail-Adresse ein. Du bekommst einen Link zum Zurücksetzen deines Passworts.
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              label="E-Mail"
              type="email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{ mb: 3 }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                py: 1.2,
                bgcolor: '#3dd47e',
                color: '#181c34',
                fontWeight: 700,
                '&:hover': { bgcolor: '#2ba862' },
              }}
            >
              {loading ? <CircularProgress size={22} sx={{ color: '#181c34' }} /> : 'Reset-Link senden'}
            </Button>
          </form>

          <Typography variant="body2" sx={{ textAlign: 'center', mt: 2, color: '#8899aa' }}>
            <RouterLink to="/login" style={{ color: '#3dd47e', textDecoration: 'none' }}>
              Zurück zum Login
            </RouterLink>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PasswortVergessenPage;
